import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fetchProducts = (category) =>
  api.get("/products", { params: category ? { category } : {} }).then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const fetchBundles = () => api.get("/bundles").then((r) => r.data);
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchArticles = () => api.get("/articles").then((r) => r.data);
export const fetchArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);
export const startCheckout = (items, origin_url) =>
  api.post("/payments/checkout", { items, origin_url }).then((r) => r.data);
export const paymentStatus = (session_id) =>
  api.get(`/payments/status/${session_id}`).then((r) => r.data);
export const fetchResources = () => api.get("/resources").then((r) => r.data);
export const downloadResourceUrl = (slug) => `${API}/downloads/${slug}`;
export const fetchReviews = (product) =>
  api.get("/reviews", { params: product ? { product } : {} }).then((r) => r.data);
export const fetchReviewsSummary = () => api.get("/reviews/summary").then((r) => r.data);
export const createReview = (payload) => api.post("/reviews", payload).then((r) => r.data);
